import { defaultFetch } from "./baseApi";

export type GroupType = {
    id: number;
    name: string;
    partnership: boolean;
    pivot: {
        companyId: number;
        groupId: number;
    };
};

export const getGroupsByCompanyId = (companyId: number) => {
    return defaultFetch<GroupType[]>(`/v0/companies/${companyId}/groups`);
}